"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useLastReadActivityKey;

var _useContext = _interopRequireDefault(require("./private/useContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useLastReadActivityKey() {
  return (0, _useContext.default)().lastReadActivityKeyState;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VMYXN0UmVhZEFjdGl2aXR5S2V5IiwidXNlQWN0aXZpdHlBY2tub3dsZWRnZW1lbnRDb250ZXh0IiwibGFzdFJlYWRBY3Rpdml0eUtleVN0YXRlIl0sInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvcHJvdmlkZXJzL0FjdGl2aXR5QWNrbm93bGVkZ2VtZW50L3VzZUxhc3RSZWFkQWN0aXZpdHlLZXkudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHVzZUFjdGl2aXR5QWNrbm93bGVkZ2VtZW50Q29udGV4dCBmcm9tICcuL3ByaXZhdGUvdXNlQ29udGV4dCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZUxhc3RSZWFkQWN0aXZpdHlLZXkoKTogcmVhZG9ubHkgW3N0cmluZ10ge1xuICByZXR1cm4gdXNlQWN0aXZpdHlBY2tub3dsZWRnZW1lbnRDb250ZXh0KCkubGFzdFJlYWRBY3Rpdml0eUtleVN0YXRlO1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7QUFFZSxTQUFTQSxzQkFBVCxHQUFxRDtFQUNsRSxPQUFPLElBQUFDLG1CQUFBLElBQW9DQyx3QkFBM0M7QUFDRCJ9